export const SET_CURRENT_PAGE = "storeCurrentPageData";
export const CURRENT_PAGE_ERROR = "currenPageError";
export const SET_PROJECT_DATA = "setProjectData";
export const PROJECT_DATA_ERROR = "projectDataError";
export const SET_PROJECT_PARENT_PAGE = "setprojectParentPage";
export const SET_PROJECT_CURRENT_PAGE = "setprojectCurrentPage";
export const SET_MAIN_MENU = "setMainMenu";
export const SET_MAIN_MENU_ERROR = "setMainMenuError";
export const ADD_ANIMATION = "addMainTimeLineAnimation";
export const SET_MENU_LOADED = "setMenuLoaded";
export const SET_PRELOADER_LOADED = "setPreloaderLoaded";

export const SET_AUTH_DATA: string = "setAuthData";

export const AUTH_DATA_ERROR: string = "authDataError";

export const CLEAR_AUTH_DATA: string = "clearAuthData";

export const RETRIEVE_SESSION_DATA: string = "retrieveSessionData";

export const TOGGLE_LOGIN: string = "toggleLogin";

export const SET_PROFILE_DATA: string = "setProfileData";

export const SET_PROFILE_ERROR: string = "setProfileError";

// social icon mutation

export const SET_SOCIAL = "setSocial";
export const SET_SOCIAL_ERROR = "setSocialError";
export const SET_SOCIAL_LOADED = "setSocialLoaded";

// global icon mutation

export const SET_GLOBAL = "setGlobal";
export const SET_GLOBAL_ERROR = "setGlobalError";
export const SET_GLOBAL_LOADED = "setGlobalLoaded";

export const SET_PROJECT_SETTINGS = "setProjectSettings";
export const SET_PROJECT_SETTINGS_ERROR = "setProectSettingsError";
